export const VisitRequestClassify = {
    List: [
        {label: "VMS_VISIT_REQUEST_CLASSIFY_NONE", value: "00"},
        {label: "VMS_VISIT_REQUEST_CLASSIFY_VISITOR", value: "01"},
        {label: "VMS_VISIT_REQUEST_CLASSIFY_CONSTRUCTION", value: "02"},
        {label: "VMS_VISIT_REQUEST_CLASSIFY_SHIPPING", value: "03"},
        {label: "VMS_VISIT_REQUEST_CLASSIFY_SPECIAL_VEHICLE", value: "04"},
        {label: "VMS_VISIT_REQUEST_CLASSIFY_EMPLOYEE_VEHICLE", value: "05"},
    ],
    Map: new Map<string, string>([
        ['00', 'VMS_VISIT_REQUEST_CLASSIFY_NONE'],
        ['01', 'VMS_VISIT_REQUEST_CLASSIFY_VISITOR'],
        ['02', 'VMS_VISIT_REQUEST_CLASSIFY_CONSTRUCTION'],
        ['03', 'VMS_VISIT_REQUEST_CLASSIFY_SHIPPING'],
        ['04', 'VMS_VISIT_REQUEST_CLASSIFY_SPECIAL_VEHICLE'],
        ['05', 'VMS_VISIT_REQUEST_CLASSIFY_EMPLOYEE_VEHICLE'],
    ]),
    Enum: {
        None: '00',
        Visitor: '01',
        Construction: "02",
        Shipping: '03',
        SpecialVehicle: "04",
        EmployeeVehicle: '05'
    }
};